import {createSelector} from "reselect";

const sims = (state) => state.sim;

const simData = createSelector(sims, (data) => data?.sims_data || {});

export const getSimsList = createSelector(simData, (data) => data?.results || []);

export const getTotalCount = createSelector(simData, (data) => data?.count);

export const getSimsPaginationUrls = createSelector(simData, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const getSimModalStatus = createSelector(sims, (sims) => sims.simModalStatus);

export const getSimModalData = createSelector(sims, (sims) => sims.simModalData);

export const getSimUsageDetails = createSelector(sims, (sims) => sims.simUsageDetails);
